<ngb-accordion #acc="ngbAccordion" [destroyOnHide]="false" class="notary-accordion no-border" *ngIf="accordionData" activeIds="panel0">
  <ng-container *ngFor="let panel of accordionData; let i = index">
    <ngb-panel id="panel{{i}}">
      <ng-template ngbPanelTitle>

        <!-- {{panel.properties.title}}  -->
        <div ngbPanelToggle>
            <span class="align-middle">{{panel.properties.title}}&nbsp;</span>
            <span class="align-middle">
              <mat-icon aria-hidden="false" aria-label="Example home icon"  *ngIf="!acc.activeIds.includes('panel'+ i)">expand_more</mat-icon>
              <mat-icon aria-hidden="false" aria-label="Example home icon"  *ngIf="acc.activeIds.includes('panel'+ i)">expand_less</mat-icon>
            </span>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="row  accordionPanel">
          <div class="col-xs-12 col-sm-12 col-md-12 multirow-table-wrapper">

            <div class="mt-3">
                <app-submitable-table [tableData]="panel.panelproperty"></app-submitable-table>
            </div>

            <div class="mt-3">
                <app-price-component  [priceObject]="panel.priceObject" [fg]="panel.priceObject.formGroup"></app-price-component>
            </div>

            <div class="mt-3">
              <app-submitable-table [tableData]="panel.partiesInvolved"></app-submitable-table>
            </div>

            <div class="mt-3">
              <app-submitable-table [tableData]="panel.propertiesTable" [additionltableData]="panel.allproperties"></app-submitable-table>
            </div>

            <div class="mt-3">
                <app-cadastre-attachment-table [tableData]="panel.documentsTable"></app-cadastre-attachment-table>
            </div>
          </div>
      </div>
      </ng-template>
    </ngb-panel>

  </ng-container>
</ngb-accordion>
